import styled from '@emotion/styled'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import * as React from 'react'

export type StepStateName = 'current' | 'pending' | 'complete'

type StepTabProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isSelected: boolean
  onClick?: () => void
  state: StepStateName
  stepNumber: number
}

const BaseStepButton = styled.button<StepTabProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-bottom: ${({ isSelected }) => (isSelected ? '2px solid var(--Wine-Light)' : 'none')};
  background-color: var(--Transparent);
  padding: 0 0 24px;
  display: flex;
  cursor: pointer;

  label {
    margin: 0;
    cursor: pointer;
  }
`

const PendingStepButton = styled(BaseStepButton)`
  color: var(--White80);
  cursor: unset !important;
`

const CurrentStepButton = styled(BaseStepButton)`
  color: var(--Graphite);
`

const StyledCheckCircleIcon = styled(CheckCircleIcon)`
  color: var(--Success);
  width: 22px !important;
  height: 22px !important;
`

const CompleteStepButton = styled(BaseStepButton)`
  color: var(--Success);
  cursor: pointer;
`

const StepNumber = styled.div<{ state: 'pending' | 'current' }>`
  border-radius: 50%;
  width: 22px;
  height: 22px;
  line-height: 22px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ state }) => (state === 'current' ? 'black' : 'lightgray')} !important;
  color: var(--White);
`

const StepName = styled.span`
  padding-left: 10px;
`

export const StepTab = ({ children, isSelected, onClick, state, stepNumber }: StepTabProps) => {
  const onClickHandler = state !== 'pending' ? onClick : () => false

  switch (state) {
    case 'pending': {
      return (
        <PendingStepButton
          isSelected={isSelected}
          state={state}
          stepNumber={stepNumber}
          onClick={onClickHandler}
        >
          <StepNumber state="pending">{stepNumber}</StepNumber> <StepName>{children}</StepName>
        </PendingStepButton>
      )
    }
    case 'current': {
      return (
        <CurrentStepButton
          isSelected={isSelected}
          state={state}
          stepNumber={stepNumber}
          onClick={onClickHandler}
        >
          <StepNumber state="current">{stepNumber}</StepNumber> <StepName>{children}</StepName>
        </CurrentStepButton>
      )
    }
    case 'complete': {
      return (
        <CompleteStepButton
          isSelected={isSelected}
          state={state}
          stepNumber={stepNumber}
          onClick={onClickHandler}
        >
          <StyledCheckCircleIcon />
          <StepName>{children}</StepName>
        </CompleteStepButton>
      )
    }
  }
}
